export default {
  brand: {
    label: 'ABC'
  }
};
